import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteScreenTitle: {
        id:'tfpa.quoteandbind.wizard.residential.quoteScreenTitle',
        defaultMessage: 'Quote'
    },
    paymentRequestFailed: {
        id:'tfpa.quoteandbind.wizard.residential.paymentRequestFailed',
        defaultMessage: 'Missing Required Fields'
    },
    sorryYourPaymentCouldNotBeProcessedAtThisTime: {
        id:'tfpa.quoteandbind.wizard.residential.sorryYourPaymentCouldNotBeProcessedAtThisTime',
        defaultMessage: 'Please enter the Estimated Replacement Cost and Estimated Actual Cash Value before editing any other fields.',
    },
    documentMessage: {
        id:'tfpa.quoteandibind.wizard.residential.documentMessage',
        defaultMessage: 'The Quote Summary will be available shortly on the documents.',
    },
    documentConfirmButton: {
        id:'tfpa.quoteandibind.wizard.residential.Go to Documents',
        defaultMessage: 'Go to Documents',
    },
    documentContinueButton: {
        id:'tfpa.quoteandibind.wizard.residential.Continue',
        defaultMessage: 'Continue',
    },
    documentErrorMessage: {
        id:'tfpa.quoteandibind.wizard.residential.The transaction must be quoted to generate print quote summary.',
        defaultMessage: 'The transaction must be quoted to generate print quote summary.',
    },
    documentErrorTitle: {
        id:'tfpa.quoteandibind.wizard.residential.Transaction Not Quoted',
        defaultMessage: 'Transaction Not Quoted',
    },
    documentCloseButton: {
        id:'tfpa.quoteandibind.wizard.residential.Close',
        defaultMessage: 'Close',
    },
    cancelQuote: {
        id:'tfpa.quoteandibind.wizard.residential.Cancel Quote',
        defaultMessage: 'Are you sure you want to exit?',
    },
    cancelMessage: {
        id:'tfpa.quoteandibind.wizard.residential.Are you sure you want to cancel the new quote?',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    cancelMessageButton: {
        id:'tfpa.quoteandibind.wizard.residential.Cancel',
        defaultMessage: 'Cancel',
    },
    cancelMessageYesButton: {
        id:'tfpa.quoteandibind.wizard.residential.Yes',
        defaultMessage: 'Yes',
    },
    continueLabel: {
        id:'tfpa.quoteandbind.wizard.residential.continueLabel',
        defaultMessage: 'Continue'
    },
    noCoveragesSelected: {
        id:'tfpa.quoteandbind.wizard.residential.noCoveragesSelected',
        defaultMessage: 'Please select at least one coverage.'
    },
    backToTopLabel: {
        id:'tfpa.quoteandbind.wizard.residential.backToTopLabel',
        defaultMessage: 'Back to Top'
    },
    dwellingError: { // DE16619
        id:'tfpa.quoteandbind.wizard.residential.Must be no more than $1,000,000',
        defaultMessage: 'Limit: Must be no more than $1,000,000'
    },
    occupancyErrorTitle: {
        id:'tfpa.quoteandbind.wizard.residential.occupancyErrorTitle',
        defaultMessage: 'Invalid Coverage Option'
    },
    permiumBoxChangeTitle: {
         "id": "quoteandibind.wizard.residential.changequoteInstructions",
          "defaultMessage": "Please select coverage options and click the 'Calculate Premium' button to quote this Policy Change."
    },
    permiumBoxSubTitle: {
        "id": "quoteandibind.wizard.residential.subquoteInstructions",
         "defaultMessage": "Please select coverage options and click the 'Calculate Premium' button to quote this Submission."
   },
});
